<div class="filtersWeb" *ngIf="utils.screenSizeObj.width >= 768">
  <h2 class="heading"> <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/product-listing/plpCart.svg'" alt="Wishlist Icon | Luminous"> FILTERS</h2>
  <div class="divider">
  </div>
  <div class="accordionContainer">
    <mat-accordion class="filterAccordion" multi>
      <div *ngFor="let item of utils.filterData;let isFirst = first" class="filterOuterContainer">
        <mat-expansion-panel [expanded]="checkExpansion(item)">
          <mat-expansion-panel-header>
            <mat-panel-description>
              <div>
                <div class="filterHead">
                  {{item.filterDisplayNames}}
                </div>
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="form-check" [hidden]="item.filterID == 'sb'"
            *ngFor="let value of item.filterValues; let i = index">
            <mat-checkbox [checked]="value.checked" (change)="onFilterClick(value,$event.checked,false)">
              {{value.filterValue}}
            </mat-checkbox>
          </div>
          <mat-radio-group *ngIf="item.filterID == 'sb'" class="radio-group" name="sortByRadio" ngDefaultControl
            (change)="radioButtonClicked($event,item,false)">
            <mat-radio-button *ngFor="let value of item.filterValues" class="radio-button" [value]="value.filterValueId"
              [checked]="value.checked">
              {{value.filterDisplayValue}}
            </mat-radio-button>
          </mat-radio-group>
        </mat-expansion-panel>
      </div>
    </mat-accordion>
  </div>
</div>

<div class="filtersMob" *ngIf="utils.screenSizeObj.width < 768">
  <div class="headContainer d-flex justify-content-between align-items-center">
    <h2 class="heading">Filters</h2>
    <span class="clear" (click)="clearAll()">Clear All</span>
  </div>
  <div class="filtersMobBody d-flex">
    <div class="filterHeadContainer">
      <div class="filterHead" *ngFor="let item of filterDataForMobile"
        [ngClass]="{'active':activeFilterObj.filterID == item.filterID}" (click)="setFilterValues(item)">
        {{item.filterDisplayNames}}
      </div>
    </div>
    <div class="filterValueContainer" *ngIf="filterValues && filterValues.length">
      <div class="form-check" [hidden]="activeFilterObj.filterID == 'sb'"
        *ngFor="let value of filterValues; let i = index">
        <mat-checkbox [checked]="value.checked" (change)="onFilterClick(value,$event.checked,true)">
          {{value.filterValue}}
        </mat-checkbox>
      </div>
      <mat-radio-group *ngIf="activeFilterObj.filterID == 'sb'" class="radio-group" name="sortByRadio" ngDefaultControl
        (change)="radioButtonClicked($event,activeFilterObj,true)">
        <mat-radio-button *ngFor="let value of filterValues" class="form-check radio-button"
          [value]="value.filterValueId" [checked]="value.checked">
          {{value.filterDisplayValue}}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="footerContainer d-flex justify-content-between align-items-center">
    <span (click)="close()">Cancel</span>
    <span (click)="applyAll()">Apply</span>
  </div>
</div>
